import { Component, OnInit,ViewChild } from '@angular/core';
import { GridBaseCase } from "../../grid/grid.base.case";
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
declare var app;
@Component({
  selector: 'app-gridlist',
  templateUrl: './gridlist.component.html',
  styleUrls: ['./gridlist.component.scss']
})
export class GridlistComponent extends GridBaseCase{
  dataArrayList: Array<any> = [];
  month: any = new Date();
  searchDate = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) {super();  
    console.log(this.element);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  /**
   * 跳转连接
   * @param targ 
   */
  EventLink(targ){
    console.log(targ);

  }
  LoadData(PageNumber){
    let that = this;
    // console.log(that.element);
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body=HandleWebParameterContextBeforeDBRequest(body);
    if(!body.ResponseMessage.Success){
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
       /****判断是否第一页begin****/
       if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.dataArrayList = data.Status.Datas;
        // let temoobj = data.Status.Datas[0];
        // that.dataArrayList.push(temoobj);
        // data.Status.Datas.forEach(function (item) {
        //   let objfield = { 'num': { 'text': '数量', value: null } };
        //   that.element.selectItemList.selectItem.forEach((element, index) => {
        //     if (element.bindingField) {
        //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
        //     }
        //   });
        //   that.dataArrayList.push(objfield);
        // });

        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
             that.infiniteScroll.disabled = true;
        } else {
            that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })

  }
}
